import { ChevronDownLineIcon } from 'components/icons';
import Accordion, {
  AccordionProps,
  EnrichedAccordionChildProps,
} from 'components/atoms/Accordion/Accordion';
import classes from 'classnames';
import Collapsible from 'components/atoms/Collapsible/Collapsible';
import React, { useLayoutEffect, useRef } from 'react';
import styles from './QuestionsAccordion.module.scss';
import Text from 'components/atoms/Typography/Text';

export type Question = {
  question: string;
  answer: string;
};

export type QuestionAccordionProps = {
  list: Question[];
} & Omit<AccordionProps, 'children'>;

type AccordionItemProps = Question & EnrichedAccordionChildProps;

const Item = ({
  question,
  answer,
  expand,
  toggleItemState,
}: AccordionItemProps) => {
  const ref = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    if (expand && ref.current) {
      ref.current.style.transform = `rotateZ(180deg)`;
    } else if (!expand && ref.current) {
      ref.current.style.transform = `rotateZ(0deg)`;
    }
  }, [expand]);

  return (
    <div>
      <div
        className={classes(styles['item-summary'], expand && styles.expanded)}
        onClick={toggleItemState}
      >
        <span className={styles['summary-text']}>{question}</span>
        <div className={styles['summary-icon']} ref={ref}>
          <ChevronDownLineIcon />
        </div>
      </div>
      <Collapsible expand={expand}>
        <Text
          className={styles['item-content']}
          dangerouslySetInnerHTML={{ __html: answer }}
        />
      </Collapsible>
    </div>
  );
};

export default function QuestionsAccordion({
  list,
  presetValues,
  onlyOneActive,
  onItemToggle,
}: QuestionAccordionProps) {
  return (
    <Accordion
      onlyOneActive={onlyOneActive}
      presetValues={presetValues}
      onItemToggle={onItemToggle}
    >
      {list.map((item, index) => {
        return (
          <Item question={item.question} answer={item.answer} key={index} />
        );
      })}
    </Accordion>
  );
}
